import { render, staticRenderFns } from "./AccrualsSyncStatusBar.vue?vue&type=template&id=6b28244a&scoped=true"
import script from "./AccrualsSyncStatusBar.vue?vue&type=script&lang=js"
export * from "./AccrualsSyncStatusBar.vue?vue&type=script&lang=js"
import style0 from "./AccrualsSyncStatusBar.vue?vue&type=style&index=0&id=6b28244a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b28244a",
  null
  
)

export default component.exports